import type { PartnerRule } from '@shipium-corp/shipium-ts-types';
import type { RulePropertyInfo } from './types';
import type { PartnerRuleSet } from '@shipium-corp/shipium-ts-types';

export const SIMPLE_RULE_SET_1: PartnerRuleSet = {
  auditInfo: {
    createdBy: 'c67c4262-d1cf-4b2d-a3f6-d21a63f8b675',
    creationTimeStamp: '2022-12-29T21:06:08.208Z',
    lastUpdatedBy: 'c67c4262-d1cf-4b2d-a3f6-d21a63f8b675',
    lastUpdatedTimeStamp: '2022-12-29T21:06:08.208Z',
    version: 1,
  },
  name: 'Holiday ruleset for 2022',
  rules: [
    {
      rule: {
        active: true,
        archived: true,
        auditInfo: {
          createdBy: 'string',
          creationTimeStamp: '2022-12-29T21:06:08.208Z',
          lastUpdatedBy: 'string',
          lastUpdatedTimeStamp: '2022-12-29T21:06:08.208Z',
          version: 1,
        },
        carrierAndServiceMethodList: ['string'],
        criteria: [
          {
            ruleComparator: {
              ruleComparatorEnum: 'lte',
              ruleComparatorName: 'Less Than or Equal To',
            },
            compareValue: ['90210', '10101'],
            ruleProperty: {
              rulePropertyEnum: 'destination_postal',
              rulePropertyName: 'Destination Postal',
            },
            scalarUnit: {
              scalarUnitEnum: 'lb',
              scalarUnitName: 'Pounds',
            },
          },
        ],
        listType: 'block',
        name: 'Block Texas For Slow Carrier',
        description: 'Nice description',
        partnerId: 'f8569788-5001-4242-a04e-6156268011cd',
        ruleId: '3826769e-aa5b-4a98-9966-50326b5cda28',
        ruleUrn: 'urn:rule:3826769e-aa5b-4a98-9966-50326b5cda28:1',
        tenantIds: [],
        tagIds: [],
      },
      ruleId: '3826769e-aa5b-4a98-9966-50326b5cda28',
      sequence: 5,
    },
  ],
  partnerId: 'f8569788-5001-4242-a04e-6156268011cd',
  ruleSetId: '3826769e-aa5b-4a98-9966-50326b5cda28',
  ruleSetUrn: 'urn:rule:3826769e-aa5b-4a98-9966-50326b5cda28:1',
  tagIds: [],
};

export const SIMPLE_RULE_1: PartnerRule = {
  active: true,
  archived: true,
  auditInfo: {
    createdBy: 'c67c4262-d1cf-4b2d-a3f6-d21a63f8b675',
    creationTimeStamp: '2022-12-29T21:06:08.213Z',
    lastUpdatedBy: 'c67c4262-d1cf-4b2d-a3f6-d21a63f8b675',
    lastUpdatedTimeStamp: '2022-12-29T21:06:08.213Z',
    version: 1,
  },
  carrierAndServiceMethodList: ['fedex', 'fedex-ground'],
  criteria: [
    {
      ruleComparator: {
        ruleComparatorEnum: 'lte',
        ruleComparatorName: 'Less Than or Equal To',
      },
      compareValue: ['90210', '10101'],
      ruleProperty: {
        rulePropertyEnum: 'destination_postal',
        rulePropertyName: 'Destination Postal',
      },
      scalarUnit: {
        scalarUnitEnum: 'lb',
        scalarUnitName: 'Pounds',
      },
    },
  ],
  tenantIds: [],
  listType: 'block',
  name: 'Block Texas For Slow Carrier',
  description: 'Nice description.',
  partnerId: 'f8569788-5001-4242-a04e-6156268011cd',
  ruleId: '3826769e-aa5b-4a98-9966-50326b5cda28',
  ruleUrn: 'urn:rule:3826769e-aa5b-4a98-9966-50326b5cda28:1',
  tagIds: [],
};

export const SIMPLE_RULE_PROPERTY_INFO_1: RulePropertyInfo = {
  ruleComparatorType: {
    availableRuleComparators: [
      {
        ruleComparatorEnum: 'not_in',
        ruleComparatorName: 'Not In',
      },
      {
        ruleComparatorEnum: 'in',
        ruleComparatorName: 'In',
      },
    ],
    ruleComparatorTypeEnum: 'list',
    ruleComparatorTypeName: 'List',
  },
  ruleProperty: {
    rulePropertyEnum: 'destination_postal',
    rulePropertyName: 'Destination Postal',
  },
  unitType: {
    availableScalarUnits: [],
    rulePropertyUnitTypeEnum: 'none',
    rulePropertyUnitTypeName: 'None',
  },
};
